<template lang="html">
  <b-container class="p-0 todo-item text-center m-0" :class="{'on_going': task.end_time == ''}">
    <b-row no-gutters  class="w-100">
      <b-col md="auto p-1" class="font-weight-bold">
        {{ task.id + 1}}.
      </b-col>
      <b-col class="font-weight-bold" v-b-modal.modal-fix_timetask @click="$emit('select_task', task)">
        {{  task.task.title  }}
      </b-col>
      <b-col md="auto" class="p-2">
        {{ format_ms(task.duration)}}
        <!-- {{task.duration}} -->
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from 'moment';
export default {
  name:"timer_element",
  props: ["task"],
  methods:{
    format_ms: function (time) {
      if(time){
        return moment.utc(time).format('HH:mm');
      }
     },
     duration_time() {
       if(!this.task.end_time){
         this.task.duration = moment(new Date).diff(moment(this.task.start_time))
       }
       // console.log(this.task);
     },
  },
  mounted() { // update running time
      this.interval = setInterval(() => {
        this.duration_time();

      },1000); // every second
    },
}
</script>

<style lang="css" scoped>
div{
  display: flex;
}

.on_going{
  background-color: #8bc34a;
}
</style>
